// 主题编辑器可能重复加载脚本，避免重复注册。
if (!customElements.get('anibiy-christmas-sleigh')) {

  customElements.define('anibiy-christmas-sleigh', class extends HTMLElement {
    connectedCallback() {
      // Liquid 将主题 settings 中配置的选择器传到 data-cart-selector。
      const defaultSelector = '.pfac_container, .kaching-bundles-sticky-atc';
      this.cartSelector = this.dataset.cartSelector?.trim() || defaultSelector;
      try {
        document.querySelector(this.cartSelector);
      } catch (_) {
        // 后台误填选择器时使用默认值，避免整个模块脚本中断。
        this.cartSelector = defaultSelector;
      }
      this.updatePosition = () => this.updateCartOffset();

      // 规格换行、图片加载等导致购买栏高度变化时，重新计算位置。
      this.resizeObserver = new ResizeObserver(this.updatePosition);

      // 兼容购买栏 show()/hide()，以及主题编辑器动态替换购买栏。
      this.mutationObserver = new MutationObserver(changes => {
        // 修改装饰自己的 bottom 也会触发监听，忽略它，避免重复计算。
        if (changes.every(change => change.target === this)) return;
        this.watchCartBars();
      });
      this.mutationObserver.observe(document.body, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['style', 'class', 'hidden']
      });
      window.addEventListener('resize', this.updatePosition);
      this.watchCartBars();
    }

    watchCartBars() {
      this.resizeObserver.disconnect();
      document.querySelectorAll(this.cartSelector).forEach(bar => {
        this.resizeObserver.observe(bar);
      });
      this.updateCartOffset();
    }

    updateCartOffset() {
      const bars = document.querySelectorAll(this.cartSelector);
      // 没有购买栏时，交给 CSS 使用后台设置的底部留空。
      if (!bars.length) {
        this.style.removeProperty('--christmas-cart-bottom');
        return;
      }
      let offset = 0;
      for (const bar of bars) {
        const rect = bar.getBoundingClientRect();
        const style = getComputedStyle(bar);
        if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) continue;
        if (rect.height <= 0 || rect.width <= 0 || rect.top >= innerHeight || rect.bottom <= 0) continue;
        if (rect.left >= innerWidth || rect.right <= 0) continue;
        // 屏幕底边到购买栏顶部的距离，就是装饰需要抬高的距离。
        // 已包含购买栏的 padding 和安全区域，不再额外叠加。
        offset = Math.max(offset, innerHeight - Math.max(0, rect.top));
      }
      // 购买栏全部隐藏时 offset 为 0，装饰自动回到底部。
      const value = `${Math.ceil(offset)}px`;
      if (this.style.getPropertyValue('--christmas-cart-bottom') !== value) {
        this.style.setProperty('--christmas-cart-bottom', value);
      }
    }

    disconnectedCallback() {
      // 主题编辑器移除模块时，清理监听，防止重复绑定。
      this.resizeObserver.disconnect();
      this.mutationObserver.disconnect();
      window.removeEventListener('resize', this.updatePosition);
    }
  });
}
